export default {
    computed: {
        clientVersion() {
            /* The client version used to be stored in the .env files. This has changed (06/12/22)
             * since we removed .env files from version control. Now the preferred way is to use the version
             * from package.json to ease the release process.
             */
            if (this.$config?.clientVersion) return this.$config.clientVersion
            return process.env.APP_VERSION ?? null
        }
    }
}